// @ts-check
// Primeiro passo do módulo (contrato 10 de atendimento, seção 24.6): com o módulo ligado e ninguém em departamento, a
// Caixa mostra "Comece o atendimento": departamentos e membros, horário e feriados, um número como Misto (a explicação
// da decisão P3), o Atendimento nos papéis que atendem e o bot de boas-vindas. Some quando os quatro primeiros estão feitos.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { listChannels } from '../../data/conversations.js';
import { listServiceCalendar } from '../../data/service-desk.js';
import { Link } from '../../app/router.js';
import { firstStepItems } from '../../lib/service-settings-rules.js';
import { Icon } from '../../ui/icon.js';
import { t } from '../../i18n/index.js';

/** @param {{ teams: any[] }} props */
export function ServiceFirstSteps({ teams }) {
  const [channels, setChannels] = useState(/** @type {any[]} */ ([]));
  const [hasSchoolCalendar, setHasSchoolCalendar] = useState(false);
  useEffect(() => {
    listChannels().then((data) => setChannels(data.channels ?? [])).catch(() => setChannels([]));
    const year = new Date().getFullYear();
    listServiceCalendar({ from: `${year}-01-01`, to: `${year}-12-31` })
      .then((days) => setHasSchoolCalendar(days.some((/** @type {any} */ day) => day.source === 'SCHOOL')))
      .catch(() => setHasSchoolCalendar(false));
  }, []);
  const items = firstStepItems({ teams, hasSchoolCalendar, channels, hasServiceRoles: teams.some((team) => (team.members ?? []).length > 0) });
  return html`<section class="service-first-steps" data-testid="service-first-steps">
    <h2 class="service-first-steps-title"><${Icon} name="IconListCheck" size=${18} />${t('serviceDesk.firstSteps.title')}</h2>
    <p class="service-first-steps-description">${t('serviceDesk.firstSteps.description')}</p>
    <ol class="service-first-steps-list">
      ${items.map((item) => html`<li key=${item.key} data-done=${item.isDone ? 'true' : undefined}>
        <${Icon} name=${item.isDone ? 'IconCircleCheck' : 'IconCircleDashed'} size=${18} />
        <div>
          <${Link} href=${item.href} className="service-link">${t(`serviceDesk.firstSteps.items.${item.key}.title`)}<//>
          <span class="service-first-steps-hint">${t(`serviceDesk.firstSteps.items.${item.key}.hint`)}</span>
        </div>
      </li>`)}
    </ol>
  </section>`;
}
